import { render, staticRenderFns } from "./PaktaIntegritasBCE.vue?vue&type=template&id=68dacf47&"
import script from "./PaktaIntegritasBCE.vue?vue&type=script&lang=js&"
export * from "./PaktaIntegritasBCE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports